export default __webpack_public_path__ + "static/media/13_maysea.df9655aa.JPG";